import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Insta from "../../assets/Group.svg";
import linkedIn from "../../assets/linkedInBlack.svg";
import facebook from "../../assets/facebookBlack.svg";
import youtube from "../../assets/youtubeBlack.svg";
import icon from "../../assets/Logo.svg";
import at from "../../assets/at.svg";
import { toast } from "react-toastify";
import { post } from "../../helpers/api_helper";
import ThankyouScreen from "../../components/common/ThankyouScreen";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    subject: "",
    body: "",
  });

  const [charCount, setCharCount] = useState(0);
  const maxChars = 240;
  const [loading, setLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const location = useLocation();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    if (name === "body") {
      setCharCount(value.length);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const params = new URLSearchParams(formData).toString();
      await post(`/Email/SendContactUsEmail?${params}`);
      toast.success("Message sent successfully!");

      setFormData({
        fullName: "",
        email: "",
        subject: "",
        body: "",
      });
      setCharCount(0);
      setIsSuccess(true);
    } catch (error) {
      toast.error("Failed to send body. Please try again.");
      console.error("Error submitting form:", error);
    } finally {
      setLoading(false);
    }
  };
  
  useEffect(() => {
    const sectionId = location.hash.substring(1);
    const section = document.getElementById(sectionId);
    if(section){      
      window.scrollTo({
        top: section.offsetTop - 100,
        behavior: "smooth"
      });
    }
  }, [location]);

  return (
  <>
  {isSuccess ? 
    <ThankyouScreen 
      title="Thanks for Reaching Out! " 
      message="Your message has been successfully sent, and we’re excited to connect with you." 
      message2={<p className='text-lg text-darkGray/80'>In the meantime, feel free to browse our <Link to='/blog' className="text-darkPurple">blog page</Link> for more insights or follow us on social media for updates.</p>}
      className="max-w-[798px]" 
    /> : 
    <div 
      id="send-message"
      className="font-sans flex justify-center p-4 lg:p-10 bg-white"
    >
      <div className="max-w-1200 w-full flex flex-col lg:flex-row justify-between px-2">
        <div className="py-8">
          <div className="w-full">
            <h2 className="text-xl sm:text-[32px] font-bold text-darkPurple mb-2">
              We'd love to hear from you
            </h2>
            <p className="text-lg text-darkGray/80 mb-6 sm:mb-8">
              Contact us regarding any concerns or inquiries.
            </p>
          </div>

          <div className="mb-6 sm:mb-8">
            <h3 className="text-[#404653] text-xl font-bold mb-2">Email Us</h3>
            <p className="text-base text-darkGray/70 mb-2">
              Our working hours are Mon-Fri from 9am to 5pm
            </p>
            <div className="flex items-center">
              <div className="w-5 h-5 sm:w-6 sm:h-6 rounded-full flex items-center justify-center mr-2">
                <img src={icon} alt="logo" />
              </div>
              <Link
                to="https://mail.google.com/mail/?view=cm&to=info@regtechflow.com"
                target="_blank"
                className="text-[#3A3551] text-sm sm:text-sm hover:underline"
              >
                <span className="flex gap-1">
                  Info
                  <img src={at} alt="at" />
                  regtechflow.com
                </span>
              </Link>
            </div>
          </div>

          <div>
            <h3 className="text-[#404653] text-xl font-bold mb-4">Find Us At</h3>
            <div className="flex gap-6 max-lg:mt-4">
              <Link to="https://www.linkedin.com/company/regtechflow/" target="_blank">
                <img src={linkedIn} alt="LinkedIn" width={24} height={24} />
              </Link>
              <Link to="https://www.facebook.com/share/1E9RNNJx29/" target="_blank">
                <img src={facebook} alt="Facebook" width={24} height={24} />
              </Link>
              <Link to="https://www.instagram.com/regtechflow?igsh=ajliZjB3ZHdjamRw" target="_blank">
                <img src={Insta} alt="Instagram" width={24} height={24} />
              </Link>
              <Link to="https://youtu.be/Uo4vA9u1CNk"
              className="mt-[2px]"
              target='_blank'
            >
              {" "}
              <img src={youtube} alt="youtube" width={24} height={24} />
          </Link>
            </div>
          </div>
        </div>

        <div className="bg-white shadow-md rounded-3xl p-6 lg:w-[693px] my-5" style={{boxShadow: 'rgba(16, 24, 40, 0.05) 0px 8px 24px -3px, 0px 8px 24px -3px #1018281A, 0px 8px 24px -3px #1018280D'}}>
          <form onSubmit={handleSubmit} className="flex flex-col gap-8">
            <div>
              <label htmlFor="fullName" className="block text-sm text-darkGray font-medium mb-1">
                Full Name
              </label>
              <input
                type="text"
                id="fullName"
                name="fullName"
                value={formData.fullName}
                onChange={handleInputChange}
                placeholder="Full Name"
                className="w-full p-3 border border-gray-200 rounded-md text-formLabel text-sm"
                required
              />
            </div>

            <div>
              <label htmlFor="email" className="block text-sm text-darkGray font-medium mb-1">
                Work Email
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="Work Email"
                className="w-full p-3 border border-gray-200 rounded-md text-formLabel text-sm"
                required
              />
            </div>

            <div>
              <label htmlFor="subject" className="block text-sm text-darkGray font-medium mb-1">
                Select a Subject
              </label>
              <div className="relative">
                <select
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleInputChange}
                  className={`w-full p-3 border border-gray-200 rounded-md text-sm bg-white appearance-none ${
                    formData.subject === '' ? 'text-gray-400' : 'text-formLabel'
                  }`}
                  required
                >
                  <option value="" disabled className="text-[#9CA3AF]" hidden>
                    Select a Subject
                  </option>
                  <option className="text-formLabel" value="CorporateManagement">Corporate Management</option>
                  <option className="text-formLabel" value="licenseManagement">License Management</option>
                  <option className="text-formLabel" value="complianceAssurance">Compliance Assurance</option>
                  <option className="text-formLabel" value="consultantsAndAdvisor">Consultants & Advisors Solutions</option>
                  <option className="text-formLabel" value="businessOpportunity">Business Opportunity</option>
                  <option className="text-formLabel" value="others">Others</option>
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                  <svg
                    className="fill-current h-4 w-4"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    >
                    <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                  </svg>
                </div>
              </div>
            </div>

            <div>
              <label htmlFor="body" className="block text-sm text-darkGray font-medium mb-1">
                How can we help you?
              </label>
              <textarea
                id="body"
                name="body"
                value={formData.body}
                onChange={handleInputChange}
                placeholder="Please let us know what you're looking to solve with BigTechFlow"
                rows={4}
                className="w-full p-3 border border-gray-200 rounded-md text-formLabel text-sm"
                maxLength={maxChars}
                required
              ></textarea>
              <div className="flex justify-end mt-1">
                <span className="text-sm text-gray-500">
                  {charCount}/{maxChars}
                </span>
              </div>
            </div>

            <div className="pt-2">
              <button
                type="submit"
                className="w-full px-6 py-3 bg-primary text-white rounded-full hover:bg-opacity-90 transition-all duration-200 text-sm font-medium"
                disabled={loading}
              >
                {loading ? "Sending..." : "Send a message"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
     }
  </>
  );
};

export default ContactForm;
